import { createRoute } from '@tanstack/react-router';
import { Dashboard } from '../dashboard/index.js';
import { rootRoute } from './index.js';

export const dashboardRoute = createRoute({
    getParentRoute: () => rootRoute,
    path: '/dashboard',
    component: Dashboard,
});
